
import TimeComponent from './TimeComponent'
import LogoComponent from './LogoComponent'
import TextComponent from './TextComponent'
import CountDown from './CountDown'
import IframeWidget from './IframeWidget'
import FlodeWedgit from './FlodeWedgit'
import WelcomeComponent from './WelcomeComponent'
import WelcomeCardComponent from './WelcomeCardComponent'
import TodoComponent from './TodoComponent'
import ChartComponent from './ChartComponent'
import AktivatavComponent from './AktivatavComponent'
import UpNextComponent from './UpNext'
//Induviduell
import ForsaljningUtfallMotBudget from './Induviduell/ForsaljningUtfallMotBudget'
import BokadeMötenUtfallMotBudget from './Induviduell/BokadeMötenUtfallMotBudget'
import VunnaAffarer from './Induviduell/VunnaAffarer'
import ÖkadLopandeIntakt from './Induviduell/ÖkadLopandeIntakt'
import LopandeIntakt from './Induviduell/LopandeIntakt'
import SummaAvtalsfakturering from './Induviduell/SummaAvtalsfakturering'
import SummaAvtalsVardeAbonn from './Induviduell/SummaAvtalsVardeAbonn'
import OrderVarde from './Induviduell/OrderVarde'
import BokadeNyKund1a from './Induviduell/BokadeNyKund1a'
import BokadeNyKundUppföljning from './Induviduell/BokadeNyKundUppföljning'
import BokadeBefKund from './Induviduell/BokadeBefKund'
import Avbokade from './Induviduell/Avbokade'
import GenomfördaMöten from './Induviduell/GenomfördaMöten'
import TotalFörsäljning from './Induviduell/TotalFörsäljning'
import SummaOffert from './Induviduell/SummaOffert'
import NyaOfferter from './Induviduell/NyaOfferter'
import AktiviteterKlara from './Induviduell/AktiviteterKlara'
import SkapadeProspekt from './Induviduell/SkapadeProspekt'
import AvslutadeAffärer from './Induviduell/AvslutadeAffärer'
import Aktiviteter from './Induviduell/Aktiviteter'
import Orderar from './Induviduell/Orderar'
import BokadeMötenLG from './Induviduell/BokadeMötenLG'
//Order 
import OrderStatus from './Order/OrderStatus'
import OppnaOrdrar from './Order/OppnaOrdrar'
//Projekt 
import ProjektStatus from './Projekt/ProjektStatus'
import ProjectBoards from './ProjectBoards'
import RegisterTimeComponent from './RegisterTimeComponent'
//Ärende
import AvslutadeArenden from './Arende/AvslutadeArenden'
import NyaArenden from './Arende/NyaArenden'
import TopListÖppnaArenden from './Arende/TopListÖppnaArenden'
import ArendenÖppnaPågående from './Arende/ArendenÖppnaPågående'
import StängdaNyaArendenYear from './Arende/StängdaNyaArendenYear'
import LastArenden from './Arende/LastArenden'
import OppnaArenden from './Arende/OppnaArenden'
//ForsaljningThisMonth
import ForsaljningThisMonth from './Induviduell/ForsaljningThisMonth'

import TotalSales from './Avtal/TotalSales'
import MRR from './Avtal/MRR'
import ARR from './Avtal/ARR'
import ARPU from './Avtal/ARPU'
/*
import BokadeKunderTopLista from './Möte/BokaTopLista'
import BokadeKunderTopListaG from './Möte/BokaTopListaG'
import BokadeKunderTopListaB from './Möte/BokaTopListaB'
import BokadeMotenBokadAv from './Möte/BokadeMotenBokadAv'
import BokadeMotenBokadTill from './Möte/BokadeMotenBokadTill'
import AvBokadeMotenBokadAv from './Möte/AvBokadeMotenBokadAv'
import AvBokadeMotenBokadTill from './Möte/AvBokadeMotenBokadTill'
import GenomfordaMotenBokadAv from './Möte/GenomfordaMotenBokadAv'
import GenomfordaMotenBokadTill from './Möte/GenomfordaMotenBokadTill'
import PlaneradeMotenBokadTill from './Möte/PlaneradeMotenBokadTill'


import SaljTopList from './Sälj/SaljTopList'
import TopListTags from './Sälj/TopListTags'
import LynesSamtal from './Samtal/LynesSamtal'
import LynsesAntalSamtal from './Samtal/LynsesAntalSamtal'
import LynesSamtalAvgDur from './Samtal/LynesSamtalAvgDur'
import LynesSamtalTable from './Samtal/LynesSamtalTable'
import LynesSamtalGraph from './Samtal/LynesSamtalGraph'
import ProgresBarBudget from './Sälj/ProgresBarBudget'
import TopSellers from './Sälj/TopSellers'
import VunnaAffärer from './Sälj/VunnaAffärer'
import VärdeAffärer from './Sälj/VärdeAffärer'


import AvslutadeArenden from './Arende/AvslutadeArenden'





import AvtalLoperutOmforYear from './Avtal/LoperutOmforYear'
import AvtalsTyper from './Avtal/AvtalsTyper'
import AvtalGrowth from './Avtal/AvtalGrowth'
import AvtalsVärde from './Avtal/AvtalsValue'
import AvtalVardeYear from './Avtal/AvtalVardeYear'
import AvtalsValueBilling from './Avtal/AvtalsValueBilling'
import AvtalsValueBillingYear from './Avtal/AvtalsValueBillingYear'
*/
//Setting types :
// text, textSize, countdown, interval,intervalJ

// Categories
// 1: Övrigt
// 2: Induviduell
// 3: Översikt
// 4: Sälj
// 5: Boka
// 6: Kontor
// 7: Ärende
// 8: Avtal
// 9: Dialer
// 10: Projekt
// 11:Order

export default [
  // {type: 1, title: "Widget 1", maxW:3, minW:2, maxH: 3, minH: 2, Component: ExempelWidget, settings: []},
/*Start */

  {
    type: 1,
    title: "Logga", 
    category: 1,
    maxW:3, 
    minW:2, 
    maxH: 4,
    minH: 2, 
    Component: LogoComponent,
    settings: ['BackGroudColor'],
    filter: []
  },
  {
    type: 2, 
    title: "Tid", 
    category: 1,
    maxW:3, 
    minW:1, 
    maxH: 3, 
    minH: 1, 
    Component: TimeComponent,
    settings: ['textSize','FontColor','BackGroudColor'],
    filter: []
  },
  {
    type: 3,
    title: "Nedräkning", 
    category: 1,
    maxW:12, 
    minW:1, 
    maxH: 5,
    minH: 2, 
    Component: CountDown,
    settings: ['countdown','textSize','FontColor','BackGroudColor'],
    filter: []
  },
  {
    type: 4,
    title: "Text", 
    category: 1,
    maxW:5, 
    minW:2, 
    maxH: 5,
    minH: 2, 
    Component: TextComponent,
    settings: ['text','textSize','FontColor','BackGroudColor'],
    filter: []
  },
  {
    type: 404,
    title: "Chart", 
    category: 1,
    maxW: 6, 
    minW: 2, 
    maxH: 10,
    minH: 2, 
    Component: ChartComponent,
    settings: ['interval','BackGroudColor','FontColor',
    'chartType','title','hAxis','vAxis'
    ],
    filter: []
  },
  {
    type: 30,
    title: "Eget innehåll", 
    category: 1,
    maxW:12, 
    minW:2, 
    maxH: 16,
    minH: 2, 
    Component: IframeWidget,
    settings: ['linkSrc','BackGroudColor'],
    filter: []
  },
  // {
  //   type: 401,
  //   title: "Välkomma", 
  //   category: 1,
  //   maxW:5, 
  //   minW:3, 
  //   maxH: 4,
  //   minH: 2, 
  //   Component: WelcomeComponent,
  //   settings: ['textSize','BackGroudColor','FontColor','ImageHeight'],
  //   filter: []
  // },
 // {
 //    type: 403,
 //    title: "VälkommaCard", 
 //    category: 1,
 //    maxW:5, 
 //    minW:3, 
 //    maxH: 4,
 //    minH: 2, 
 //    Component: WelcomeCardComponent,
 //    settings: ['textSize','BackGroudColor','FontColor','ImageHeight'],
 //    filter: []
 //  },

  {
    type: 400,
    title: "Flöde", 
    category: 1,
    maxW:12, 
    minW:3, 
    maxH: Infinity,
    minH: 5, 
    Component: FlodeWedgit,
    settings: [],
    filter: []
  },
  {
    type: 402,
    title: "Todo", 
    category: 1,
    maxW:5, 
    minW:3, 
    maxH: Infinity,
    minH: 10, 
    Component: TodoComponent,
    settings: ['BackGroudColor'],
    filter: []
  },
   {
    type: 405,
    title: "Aktiva tävlingar", 
    category: 1,
    maxW:5, 
    minW:3, 
    maxH: 8,
    minH: 3, 
    Component: AktivatavComponent,
    settings: [],
    filter: []
  }, 
   {
    type: 406,
    title: "Up next", 
    category: 1,
    maxW:5, 
    minW:3, 
    maxH: 8,
    minH: 3, 
    Component: UpNextComponent,
    settings: [],
    filter: []
  }, 
//dasd
  
  {
    type: 5,
    title: "Försäljning utfall", 
    category: 2,
    maxW:3, 
    minW:2, 
    maxH: 8,
    minH: 6, 
    Component: ForsaljningUtfallMotBudget,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: []
  },
  {
    type: 9,
    title: "Bokade möten utfall", 
    category: 2,
    maxW:3, 
    minW:2, 
    maxH: 8,
    minH: 6, 
    Component: BokadeMötenUtfallMotBudget,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: []
  },
  {
    type: 20,
    title: "Avslutade affärer", 
    category: 2,
    maxW:5, 
    minW:3, 
    maxH: 10,
    minH: 5, 
    Component: AvslutadeAffärer,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: []
  },
  
  {
    type: 21,
    title: "Aktiviteter", 
    category: 2,
    maxW:5, 
    minW:3, 
    maxH: 10,
    minH: 5, 
    Component: Aktiviteter,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: []
  },
  {
    type: 22,
    title: "Orderar", 
    category: 2,
    maxW:5, 
    minW:3, 
    maxH: 10,
    minH: 5, 
    Component: Orderar,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: []
  },
 
  {
    type: 15,
    title: "Total försäljning", 
    category: 2,
    maxW:4, 
    minW:3, 
    maxH: 8,
    minH: 6, 
    Component: TotalFörsäljning,
    settings: ['BackGroudColor'],
    filter: []
  },
  {
    type: 11,
    title: "Bokade ny kund uppföljning", 
    category: 2,
    maxW:3, 
    minW:2, 
    maxH: 2,
    minH: 1, 
    Component: BokadeNyKundUppföljning,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: []
  },
 {
    type: 12,
    title: "Bokade bef kund", 
    category: 2,
    maxW:3, 
    minW:2, 
    maxH: 2,
    minH: 1, 
    Component: BokadeBefKund,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: []
  },
  {
    type: 13,
    title: "Avbokade", 
    category: 2,
    maxW:3, 
    minW:2, 
    maxH: 2,
    minH: 1, 
    Component: Avbokade,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: []
  },
  {
    type: 14,
    title: "Genomförda möten", 
    category: 2,
    maxW:3, 
    minW:2, 
    maxH: 2,
    minH: 1, 
    Component: GenomfördaMöten,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: []
  },
  {
    type: 10,
    title: "Bokade ny kund 1a", 
    category: 2,
    maxW:3, 
    minW:2, 
    maxH: 2,
    minH: 1, 
    Component: BokadeNyKund1a,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: []
  },
   {
    type: 16,
    title: "Summa offert", 
    category: 2,
    maxW:4, 
    minW:2, 
    maxH: 6,
    minH: 3, 
    Component: SummaOffert,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: []
  },
  {
    type: 17,
    title: "NyaOfferter", 
    category: 2,
    maxW:3, 
    minW:2, 
    maxH: 5,
    minH: 3, 
    Component: NyaOfferter,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: []
  },
 {
    type: 18,
    title: "Aktiviteter klara", 
    category: 2,
    maxW:3, 
    minW:2, 
    maxH: 5,
    minH: 3, 
    Component: AktiviteterKlara,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: []
  },
    {
    type: 19,
    title: "Skapade Prospekt", 
    category: 2,
    maxW:3, 
    minW:2, 
    maxH: 5,
    minH: 3, 
    Component: SkapadeProspekt,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: []
  },
 {
    type: 6,
    title: "Vunna affärer", 
    category: 2,
    maxW:3, 
    minW:2, 
    maxH: 3,
    minH: 2, 
    Component: VunnaAffarer,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: []
  },
   {
    type: 7,
    title: "Ökad löpande intäkt", 
    category: 2,
    maxW:3, 
    minW:2, 
    maxH: 3,
    minH: 2, 
    Component: ÖkadLopandeIntakt,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: []
  },
 {
    type: 8,
    title: "Ordervärde", 
    category: 2,
    maxW:3, 
    minW:2, 
    maxH: 3,
    minH: 2, 
    Component: OrderVarde,
    settings: ['interval','BackGroudColor','FontColor','OrderVarde'],
    filter: []
  },
  {
    type: 23,
    title: "Total löpande intäkt", 
    category: 2,
    maxW:3, 
    minW:2, 
    maxH: 3,
    minH: 2, 
    Component: LopandeIntakt,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: []
  },
   {
    type: 24,
    title: "Bokade möten", 
    category: 2,
    maxW:5, 
    minW:3, 
    maxH: 6,
    minH: 6, 
    Component: BokadeMötenLG,
    settings: ['BackGroudColor','FontColor'],
    filter: []
  },

  {
    type: 29,
    title: "Avtalsfakturering", 
    category: 2,
    maxW:3, 
    minW:2, 
    maxH: 3,
    minH: 2, 
    Component: SummaAvtalsfakturering,
    settings: ['interval','BackGroudColor','FontColor','Abonnamange'],
    filter: []
  },
 {
    type: 31,
    title: "Avtalsvärde tick", 
    category: 2,
    maxW:3, 
    minW:2, 
    maxH: 3,
    minH: 2, 
    Component: SummaAvtalsVardeAbonn,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: []
  },
  {
    type: 1100,
    title: "Status ordrar", 
    category: 11,
    maxW:5, 
    minW:2, 
    minH: 2, 
    Component: OrderStatus,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: []
  },
 {
    type: 1000,
    title: "Status projekt", 
    category: 10,
    maxW:5, 
    minW:2, 
    maxH: 10,
    minH: 2, 
    Component: ProjektStatus,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: []
  },
 {
    type: 1001,
    title: "Projekt registrera tid", 
    category: 10,
    maxW:12, 
    minW:2, 
    maxH: 2,
    minH: 1, 
    Component: RegisterTimeComponent,
    settings: ['BackGroudColor'],
    filter: []
  },
 {
    type: 1002,
    title: "Projekttavlor", 
    category: 10,
    maxW:12, 
    minW:3, 
    maxH: 12,
    minH: 4, 
    Component: ProjectBoards,
    settings: [],
    filter: []
  },
   {
    type: 38,
    title: "Stängda ärenden", 
    category: 7,
    maxW:3, 
    minW:2, 
    maxH: 5,
    minH: 3, 
    Component: AvslutadeArenden,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: ['case-type-category', 'date-range']
  },
  {
    type: 39,
    title: "Nya ärenden", 
    category: 7,
    maxW:3, 
    minW:2, 
    maxH: 5,
    minH: 3, 
    Component: NyaArenden,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: ['case-type-category', 'date-range']
  },
  {
    type: 40,
    title: "Topp öppna ärenden", 
    category: 7,
    maxW:5, 
    minW:3, 
    maxH: 8,
    minH: 6, 
    Component: TopListÖppnaArenden,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: ['case-type-category', 'date-range']
  },
  {
    type: 41,
    title: "Ärenden ålder", 
    category: 7,
    maxW:5, 
    minW:3, 
    maxH: 10,
    minH: 5, 
    Component: ArendenÖppnaPågående,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: ['case-type-category', 'date-range']
  },
 {
    type: 42,
    title: "Ärenden", 
    category: 7,
    maxW:8, 
    minW:4, 
    maxH: 9,
    minH: 6, 
    Component: StängdaNyaArendenYear,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: ['case-type-category', 'date-range']
  },
  {
    type: 43,
    title: "Senaste ärenden", 
    category: 7,
    maxW:5, 
    minW:3, 
    maxH: 17,
    minH: 5, 
    Component: LastArenden,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: ['case-type-category', 'date-range']
  },
  {
    type: 45,
    title: "Öppna ärenden", 
    category: 7,
    maxW:3, 
    minW:2, 
    maxH: 5,
    minH: 3, 
    Component: OppnaArenden,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: ['case-type-category', 'date-range']
  },
  {
    type: 1101,
    title: "Öppna ordrar", 
    category: 11,
    maxW:3, 
    minW:2, 
    maxH: 5,
    minH: 3, 
    Admin:1,
    Component: OppnaOrdrar,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: [ 'date-range']
  },
  {
    type: 1102,
    title: "Försäljning denna måna", 
    category: 2,
    maxW:3, 
    minW:2, 
    maxH: 5,
    minH: 3, 
    Admin:1,
    Component: ForsaljningThisMonth,
    settings: ['interval','BackGroudColor','FontColor'],
    filter: [],
		hidden: true
  },
  {
    type: 73,
    title: "Total försäljning", 
    category: 8,
    maxW:8, 
    minW:3, 
    maxH: 9,
    minH: 4, 
    Component: TotalSales,
    settings: ['mainValue', 'interval', 'BackGroudColor','FontColor'],
    filter: []
  },
  {
    type: 74,
    title: "MRR", 
    category: 8,
    maxW:8, 
    minW:3, 
    maxH: 9,
    minH: 4, 
    Component: MRR,
    settings: ['mainValue', 'BackGroudColor','FontColor'],
    filter: []
  },
  {
    type: 75,
    title: "ARR", 
    category: 8,
    maxW:8, 
    minW:3, 
    maxH: 9,
    minH: 4, 
    Component: ARR,
    settings: ['mainValue', 'BackGroudColor','FontColor'],
    filter: []
  },
  {
    type: 76,
    title: "ARPU", 
    category: 8,
    maxW:8, 
    minW:3, 
    maxH: 9,
    minH: 4, 
    Component: ARPU,
    settings: ['mainValue', 'userCount', 'BackGroudColor','FontColor'],
    filter: []
  },
/*   */
/* End */





/*  {
    type: 25,
    title: "Topplista boka", 
    category: 5,
    maxW:7, 
    minW:3, 
    maxH: 16,
    minH: 6, 
    Component: BokadeKunderTopLista,
    settings: ['days'],
    filter: []
  },
  {
    type: 26,
    title: "Topplista sälj", 
    category: 4,
    maxW:7, 
    minW:3, 
    maxH: 16,
    minH: 6, 
    Component: SaljTopList,
    settings: ['interval'],
    filter: []
  },
  {
    type: 27,
    title: "Topplista godkända möten", 
    category: 5,
    maxW:7, 
    minW:3, 
    maxH: 16,
    minH: 6, 
    Component: BokadeKunderTopListaG,
    settings: ['days'],
    filter: []
  },
  {
    type: 28,
    title: "Topplista bokade möten", 
    category: 5,
    maxW:7, 
    minW:3, 
    maxH: 16,
    minH: 6, 
    Component: BokadeKunderTopListaB,
    settings: ['days'],
    filter: []
  },

 
  
  {
    type: 32,
    title: "Artikel taggar", 
    category: 2,
    maxW:7, 
    minW:3, 
    maxH: 16,
    minH: 6, 
    Component: TopListTags,
    settings: ['tags', 'interval', 'users', 'titel', 'start-date'],
    filter: []
  },
  {
    type: 33,
    title: "Lynes samtalstatistik", 
    category: 6,
    maxW:12, 
    minW:3, 
    maxH: 16,
    minH: 6, 
    Component: LynesSamtal,
    settings: ['interval'],
    filter: []
  },
  {
    type: 34,
    title: "Utfall mot budget", 
    category: 4,
    maxW:12, 
    minW:6, 
    maxH: 4,
    minH: 3, 
    Component: ProgresBarBudget,
    settings: ['interval'],
    filter: []
  },
  {
    type: 35,
    title: "Värde av vunna affärer per anställd", 
    category: 4,
    maxW:12, 
    minW:6, 
    maxH: 10,
    minH: 7, 
    Component: TopSellers,
    settings: ['interval'],
    filter: []
  },
  {
    type: 36,
    title: "Vunna affärer", 
    category: 4,
    maxW:6, 
    minW:4, 
    maxH: 10,
    minH: 5, 
    Component: VunnaAffärer,
    settings: ['interval'],
    filter: []
  },
  {
    type: 37,
    title: "Värde av vunna affärer", 
    category: 4,
    maxW:6, 
    minW:4, 
    maxH: 10,
    minH: 5, 
    Component: VärdeAffärer,
    settings: ['interval'],
    filter: []
  },

 
  {
    type: 44,
    title: "Avtal löper ut", 
    category: 8,
    maxW:8, 
    minW:4, 
    maxH: 9,
    minH: 6, 
    Component: AvtalLoperutOmforYear,
    settings: [],
    filter: ['date-range']
  },
  {
    type: 45,
    title: "Öppna ärenden", 
    category: 7,
    maxW:3, 
    minW:2, 
    maxH: 5,
    minH: 3, 
    Component: OppnaArenden,
    settings: [],
    filter: ['case-type-category', 'date-range']
  },
  {
    type: 46,
    title: "Avtalstyper", 
    category: 8,
    maxW:5, 
    minW:2, 
    maxH: 17,
    minH: 5, 
    Component: AvtalsTyper,
    settings: ['interval'],
    filter: []
  },
  {
    type: 47,
    title: "Avtal tillväxt", 
    category: 8,
    maxW:5, 
    minW:3, 
    maxH: 10,
    minH: 5, 
    Component: AvtalGrowth,
    settings: ['typeoptiongrowth'],
    filter: []
  },
  {
    type: 48,
    title: "Avtalsvärde", 
    category: 8,
    maxW:5, 
    minW:3, 
    maxH: 10,
    minH: 5, 
    Component: AvtalsVärde,
    settings: [],
    filter: []
  },
  {
    type: 49,
    title: "Avtalsvärde år", 
    category: 8,
    maxW:10, 
    minW:6, 
    maxH: 7,
    minH: 7, 
    Component: AvtalVardeYear,
    settings: [],
    filter: []
  },
  {
    type: 50,
    title: "Avtalsfakturering", 
    category: 8,
    maxW:5, 
    minW:3, 
    maxH: 10,
    minH: 5, 
    Component: AvtalsValueBilling,
    settings: [],
    filter: []
  },
  {
    type: 51,
    title: "Fakturering", 
    category: 8,
    maxW:8, 
    minW:4, 
    maxH: 9,
    minH: 6, 
    Component: AvtalsValueBillingYear,
    settings: [],
    filter: []
  },
  {
    type: 52,
    title: "Antal samtal", 
    category: 6,
    maxW:3, 
    minW:2, 
    maxH: 5,
    minH: 3, 
    Component: LynsesAntalSamtal,
    settings: ['interval'],
    filter: []
  },
  {
    type: 53,
    title: "Samtalslängd snitt", 
    category: 6,
    maxW:5, 
    minW:2, 
    maxH: 4,
    minH: 3, 
    Component: LynesSamtalAvgDur,
    settings: ['interval'],
    filter: []
  },
  {
    type: 54,
    title: "Senaste samtalen", 
    category: 6,
    maxW:5, 
    minW:3, 
    maxH: 17,
    minH: 5, 
    Component: LynesSamtalTable,
    settings: ['interval'],
    filter: []
  },
  {
    type: 55,
    title: "Senaste samtal 7 dagar", 
    category: 6,
    maxW:12, 
    minW:3, 
    maxH: 10,
    minH: 8, 
    Component: LynesSamtalGraph,
    filter: []
  },
  {
    type: 56,
    title: "Bokade Möten (bokad av)", 
    category: 5,
    maxW:7, 
    minW:3, 
    maxH: 16,
    minH: 6, 
    Component: BokadeMotenBokadAv,
    settings: ['interval'],
    filter: []
  },
  {
    type: 57,
    title: "Bokade Möten (bokad till)", 
    category: 5,
    maxW:7, 
    minW:3, 
    maxH: 16,
    minH: 6, 
    Component: BokadeMotenBokadTill,
    settings: ['interval'],
    filter: []
  },
  {
    type: 58,
    title: "Avbokade Möten (Bokad av)", 
    category: 5,
    maxW:7, 
    minW:3, 
    maxH: 16,
    minH: 6, 
    Component: AvBokadeMotenBokadAv,
    settings: ['interval'],
    filter: []
  },
  {
    type: 59,
    title: "Avbokade Möten (Bokad till)", 
    category: 5,
    maxW:7, 
    minW:3, 
    maxH: 16,
    minH: 6, 
    Component: AvBokadeMotenBokadTill,
    settings: ['interval'],
    filter: []
  },
  {
    type: 60,
    title: "Genomförda möten tabell (bokad av)", 
    category: 5,
    maxW:7, 
    minW:3, 
    maxH: 16,
    minH: 6, 
    Component: GenomfordaMotenBokadAv,
    settings: ['interval'],
    filter: []
  },
  {
    type: 61,
    title: "Genomförda möten tabell (bokad till)", 
    category: 5,
    maxW:7, 
    minW:3, 
    maxH: 16,
    minH: 6, 
    Component: GenomfordaMotenBokadTill,
    settings: ['interval'],
    filter: []
  },
  {
    type: 62,
    title: "Planerade Möten (Bokade till)", 
    category: 5,
    maxW:7, 
    minW:3, 
    maxH: 16,
    minH: 6, 
    Component: PlaneradeMotenBokadTill,
    settings: ['intervalJ'],
    filter: []
  },*/
]
